import React, { useMemo } from "react";
import { runTaxonomyTrawl } from "../controllers/TaxonomyTrawlerController";

/**
 * 🕵️ TAXONOMY TRAWLER VIEW
 * Location: src/registered/site-admin/components/Workflow-esg/views/axonomyTrawlerView.jsx
 */
export default function TaxonomyTrawlerView({ results, selectedFile }) {
  // 🎯 Execute the Trawl logic against the worksheets in memory
  const auditData = useMemo(() => {
    if (!results?.worksheets) return [];
    return runTaxonomyTrawl(results.worksheets);
  }, [results]);

  // Extract metadata for the "Structural Integrity" section
  const conceptCount = Object.keys(results?.esgTree?.concepts || {}).length;
  const rootCount = results?.esgTree?.roots?.length || 0;
  const calcCount = results?.calculationRecords?.length || 0;
  const dimCount = results?.definitionPairs?.length || 0;

  return (
    <div className="taxonomy-preflight-audit p-3 bg-white border rounded shadow-sm animate__animated animate__fadeIn">
      {/* HEADER SECTION */}
      <div className="border-bottom pb-2 mb-3">
        <h5 className="fw-bold text-dark mb-1" style={{ letterSpacing: '1px' }}>ESRS TAXONOMY PRE-FLIGHT AUDIT</h5>
        <div className="extra-small text-muted font-monospace">
          <div>Source Asset: <span className="text-primary">{selectedFile?.filename}</span></div>
          <div>Run Date: {new Date().toLocaleString()}</div>
        </div>
      </div>

      {/* 1. PHYSICAL RECONCILIATION */}
      <section className="mb-4">
        <h6 className="small fw-bold text-uppercase border-start border-4 border-primary ps-2 mb-3">
          1. PHYSICAL RECONCILIATION (SQL STAGING PREVIEW)
        </h6>
        <div className="table-responsive">
          <table className="table table-sm table-hover border" style={{ fontSize: '11px' }}>
            <thead className="table-light">
              <tr>
                <th className="ps-3">Property</th>
                <th className="text-center">Unique</th>
                <th className="text-center">Total</th>
                <th className="text-center">MaxLen</th>
              </tr>
            </thead>
            <tbody>
              {auditData.length > 0 ? auditData.map((row, idx) => (
                <tr key={idx}>
                  <td className="ps-3 fw-bold">{row.ColumnName}</td>
                  <td className="text-center font-monospace">{row.UniqueValueCount}</td>
                  <td className="text-center font-monospace">{row.TotalOccurrences}</td>
                  <td className="text-center">
                    <span className={`badge ${row.MaxLength >= 250 ? 'bg-danger-subtle text-danger' : 'bg-light text-dark border'}`}>
                      {row.MaxLength}
                    </span>
                  </td>
                </tr>
              )) : (
                <tr><td colSpan="4" className="text-center py-3 text-muted">No physical data mapped.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </section>

      {/* 2. STRUCTURAL INTEGRITY */}
      <section className="bg-light p-3 rounded border">
        <h6 className="small fw-bold text-uppercase mb-3">2. STRUCTURAL INTEGRITY & LOGICAL MAPPING</h6>
        <div className="row g-2 font-monospace" style={{ fontSize: '12px' }}>
          <div className="col-6">Total Concepts Identified: <span className="fw-bold">{conceptCount}</span></div>
          <div className="col-6">Root Chapters Detected: <span className="fw-bold">{rootCount}</span></div>
          <div className="col-6">Calculation Rules: <span className="fw-bold">{calcCount}</span></div>
          <div className="col-6">Dimension Pairs: <span className="fw-bold">{dimCount}</span></div>
        </div>
      </section>

      <div className="mt-3 p-2 bg-white italic border-top">
        <p className="extra-small text-muted mb-0">
          Note: This report validates the local Discovery Pass. Actual SQL ingestion will be performed by the Python Lambda service.
        </p>
      </div>
    </div>
  );
}